'use-strict'
import React from "react";
import {
  mainReducer,
  store,
  SET_PERMISSIONS,
  SET_ROLES,
  UN_AUTH_PATH,
  RouteGuard,
  HasRole,
  HasPermission,
} from 'react-role-permission'
import roles from "./roles.json"
import jwt from 'jwt-decode'
import config from '../app/config';

const signin = async (username, password) => {
  'use-strict'
  try {
    const body = `{"username" : "${username}", "password" : "${password}"}`;

    let headers = {
      "Content-Type": "application/json",
      "Access-Control-Request-Method": 'POST',
      "Access-Control-Request-Headers": "authorization,content-type"
    };

    //TODO Da riattivare dopo test aggancio con BE-SERVER

    // const response = await fetch('https://apiadmin-stg.coinbar.io/coinbar/api/v1/auth/token', requestOptions);
    const response = await callserver('authenticate', 'POST', headers, body);
    const jsondata = await response.json();

    if (response.status == 200) {
      const user = jwt(jsondata.token);
      console.log(user);
      localStorage.setItem('session_token', jsondata.token);
      localStorage.setItem('session_expire', user.exp);
      localStorage.setItem('username', username);
      localStorage.setItem('id', user.id);
      localStorage.setItem('grp', user.idGroup)
      localStorage.setItem('rl', user.role)

      store.dispatch(SET_ROLES(user.role));
      store.dispatch(SET_PERMISSIONS(roles.admin.role_pages))
      store.dispatch(UN_AUTH_PATH('/login'))
      return true;
    } else {
      localStorage.setItem('session_token', null);
      localStorage.setItem('session_expire', null);
      localStorage.setItem('username', null);
      //let msg = (result.message).indexOf('Only radix') != -1 ? ( <input type = "hidden" > Username must be a verified email </input>) :  result.message;
      //this.setInfo(msg);
    }
    return false;
  } catch (err) {
    console.log('Error during signin');
    console.log(err);
    throw err;
  }

}

const onAuthStateChanged = async (setvaliduser) => {
  'use-strict'
  try {
    const sess_token = localStorage.getItem('session_token');
    const sess_expire = localStorage.getItem('session_expire');
    ;
    const {permissions} = store.getState();
    const currentLocation = window.location.pathname;

    if (sess_token && sess_expire && new Date(sess_expire * 1000) > new Date().getTime()) {
      const user = jwt(sess_token);
      setvaliduser(true);
      store.dispatch(SET_ROLES(user.role));
      store.dispatch(SET_PERMISSIONS(roles[user.role[0]].role_pages));
      //store.dispatch(UN_AUTH_PATH('/login'))

      return true;
    // }
    //   else if(permissions.indexOf(currentLocation) > -1){
    //   console.log('you can pass!');
    //   return true
    }
    else
      {
      setvaliduser(false)
      console.log('false');
      store.dispatch(SET_ROLES([null]))
      store.dispatch(SET_PERMISSIONS(['/login']))
      return false;
    }
  } catch (err) {
    console.log('Error during onAuthStateChanged');
    console.log(err);
    throw err;
  }


}

const callserver = async (path, method, customheaders, body, isprivate) => {
  'use-strict'
  try {

    let headers = {
      "Content-Type": "application/json",
      "Access-Control-Request-Method": method,
      "Access-Control-Request-Headers": "authorization,content-type",
      "Authorization": `Bearer ${localStorage.getItem('session_token')}`
    };
    if (customheaders)
      headers = customheaders;

    var requestOptions = {
      method: method,
      headers: headers,
      body: body,
      redirect: 'follow',
      json: true
    };
    const response = await fetch(`${config.serverUrl}/${path}`, requestOptions);
    //const data = await response.json();
    if (response.status > 199 && response.status < 300) {
      return response;
    } else throw Error(`Error ${response.status} with response ${response.statusText}`);
  } catch (err) {
    console.log('Error during callserver');
    console.log(err);
    throw err;
  }


}


const app = {
  auth: {
    signInWithEmailAndPassword: signin,
    onAuthStateChanged: onAuthStateChanged
  },
  methods: {
    callserver: callserver
  }
};
export default app;
